import PropTypes from 'prop-types'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'

import Container from '../Container'
import BrandedQuote from '../BrandedQuote'
import QuoteDoubleBorder from '../QuoteDoubleBorder'

const Quote = ({ data, defaultData }) => {
  const {
    container_style: containerStyle,
    quote_logo: quoteLogo,
    quote_text: quoteText,
    single_border_quote: singleBorderQuote,
    double_border_quote: doubleBorderQuote,
    double_border_logo: doubleBorderLogo,
    background_color: bgColor,
    outer_box_color: outerBoxColor,
    inner_box_color: innerBoxColor
  } = data || {}
  const {
    single_border_quote: defaultSingleBorderQuote,
    quote_text: defaultQuoteText,
  } = defaultData

  if (containerStyle === 'Double Border') {
    return (
      <QuoteDoubleBorder data={{
        quote: doubleBorderQuote,
        logo: doubleBorderLogo,
        bgColor,
        outerBoxColor,
        innerBoxColor
      }}
      />
    )
  }

  return (
    <Wrapper center>
      <BrandedQuote
        quoteImage={isEmpty(singleBorderQuote) ? defaultSingleBorderQuote : singleBorderQuote}
        quoteText={quoteText || defaultQuoteText}
        quoteLogo={isEmpty(quoteLogo) ? null : quoteLogo}
      />
    </Wrapper>
  )
}

const Wrapper = styled(Container)`
  background-color: ${ (props) => props.theme.colors.ultraviolet[3] };

  [data-testid='quote'] {
    margin: 0;
  }
`

Quote.defaultProps = {
  data: null
}

Quote.propTypes = {
  data: PropTypes.shape({
    container_style: PropTypes.string,
    quote_logo: PropTypes.oneOfType([PropTypes.object]),
    quote_text: PropTypes.string,
    single_border_quote: PropTypes.oneOfType([PropTypes.object]),
    double_border_quote: PropTypes.oneOfType([PropTypes.object]),
    double_border_logo: PropTypes.oneOfType([PropTypes.object]),
    background_color: PropTypes.string,
    outer_box_color: PropTypes.string,
    inner_box_color: PropTypes.string
  }),
  defaultData: PropTypes.shape({
    single_border_quote: PropTypes.oneOfType([PropTypes.object]),
    quote_text: PropTypes.string,
  }).isRequired
}

export default Quote
